'use client';

import { CircularProgress, IconButton as IconButtonMUI } from '@mui/material';

import { getLoaderSize } from './buttonIcon.styled';

import type { IButtonIconProps } from './buttonIcon.type';

export const ButtonIcon = ({
  'aria-label': ariaLabel,
  'aria-haspopup': ariaHaspopup,
  children,
  color = 'inherit',
  disabled = false,
  size = 'medium',
  className = '',
  handleClick,
  sx = {},
  loading = false,
}: IButtonIconProps) => (
  <IconButtonMUI
    aria-label={ariaLabel}
    aria-haspopup={ariaHaspopup}
    color={color}
    disabled={loading || disabled}
    size={size}
    onClick={handleClick}
    className={className}
    sx={sx}
  >
    {loading ? (
      <CircularProgress
        aria-label="ButtonIcon loader"
        color={color === 'default' ? 'primary' : color}
        size={getLoaderSize(size)}
      />
    ) : (
      children
    )}
  </IconButtonMUI>
);
